import React, { useCallback, useMemo } from "react";

import { filterClasses } from "../../../../helpers/src/Styles/Style.FilterClasses";
import { DropdownOptionItem } from "../../DropdownContainer/Dropdown.Types";
import { FilterDropdown } from "../../FilterDropdown/FilterDropdown";
import { SearchInput } from "../../Input/Input.Search";
import "./SSColumnHeader.scss";

interface Props {
  filterOptions: DropdownOptionItem[];
  title?: string;
  selectedFilter: string;
  filterSelected: (filter: string) => void;
  searchUpdated: React.Dispatch<React.SetStateAction<string>>;
  searchQuery: string;
  analytics?: any;
  selectedFilters?: Record<string, string[]>;
  onChangeFilters?: (groupKey: string, filters: string[]) => void;
  onClearAllFilters?: () => void;
  filterOptionIcons?: Record<string, React.ReactNode>;
}

export function SSColumnHeader(props: Props) {
  const {
    filterOptions,
    selectedFilter,
    filterSelected,
    searchUpdated,
    searchQuery,
    title,
    analytics,
    selectedFilters,
    onChangeFilters,
    onClearAllFilters
  } = props;

  const onFilterSelected = useCallback(
    (filter: string) => {
      if (analytics && analytics.category) {
        // AnalyticsEvent(analytics.category, "Filter Type", filter);
      }
      filterSelected(filter);
    },
    [analytics, filterSelected]
  );

  const selectedOption = useMemo(() => {
    return filterOptions.find((option) => option.value === selectedFilter);
  }, [filterOptions, selectedFilter]);

  const resolvedSelectedFilters = useMemo(() => {
    if (onChangeFilters) {
      return selectedFilters ?? {};
    }

    return selectedOption ? { selection: [selectedOption.value] } : {};
  }, [onChangeFilters, selectedFilters, selectedOption]);

  const resolvedFilterOptions = useMemo(() => {
    if (onChangeFilters) {
      return filterOptions;
    }

    return filterOptions.map((option) => ({
      value: option.value,
      label: option.label,
      options: []
    }));
  }, [filterOptions, onChangeFilters]);

  const handleChange = useCallback(
    (groupKey: string, filters: string[]) => {
      if (onChangeFilters) {
        onChangeFilters(groupKey, filters);
        return;
      }

      const selected = filters[0] || "";
      onFilterSelected(selected);
    },
    [onChangeFilters, onFilterSelected]
  );

  const handleClear = useCallback(() => {
    if (onClearAllFilters) {
      onClearAllFilters();
      return;
    }

    onFilterSelected("");
  }, [onClearAllFilters, onFilterSelected]);

  return (
    <div className={filterClasses("flex w-full items-center justify-center gap-2 p-3")}>
      {title && <div className="headerTitle">{title}</div>}
      <FilterDropdown
        id="ss-column-header-filter-dropdown"
        filterOptions={resolvedFilterOptions}
        selectedFilters={resolvedSelectedFilters}
        onChangeFilters={handleChange}
        onClearAllFilters={handleClear}
      />
      <SearchInput
        id="headerSearchField"
        onChange={(e) => searchUpdated(e.target.value)}
        onClear={() => searchUpdated("")}
        value={searchQuery}
        placeholder="Search..."
      />
    </div>
  );
}
